import { Component } from '@angular/core';

@Component({
  selector: 'app-nuts-info-dialog',
  templateUrl: './nuts-info-dialog.component.html',
  styleUrls: ['./nuts-info-dialog.component.scss']
})
export class NutsInfoDialogComponent {

}
